import { readFileSync } from "fs";
import { join } from "path";

interface Project {
  docsDirectory: string;
  rootDirectory: string;
}

export function getProject() {
  const packageJsonStr = readFileSync(
    join(process.cwd(), "package.json"),
    "utf-8"
  );

  const packageJson = JSON.parse(packageJsonStr);

  return {
    docsDirectory: join(process.cwd(), packageJson.codeDocs.directory),
    rootDirectory: process.cwd(),
  } as Project;
}
